<template>
  <transition name="footnote-fade" mode="out-in">
    <div id="footnote" :key="isShow" :class="isShow ? 'open' : 'close'">
      <div class="container">
        <ul id="footnotelist">
          <div class="listTitle" :class="[isShow ? 'open' : 'close', isEditPage ? 'edit' : 'view']">
            <span>주석</span>
            <UbuttonList v-if="isShow && isEditPage" size="xsmall" align="right"
             :data="[{name: '만들기', state: 'deactive', click: createItem}]"/>
          </div>
          <li class="list" v-if="data.length === 0">
            <div v-if="isShow">작성된 주석이 없습니다</div>
          </li>
          <li v-else class="listcontainer">
            <ul>
              <li class="footnoteItem" v-for="(item, index) in data" :key="index" :class="isShow ? 'open' : 'close'">
                <span @click="bodyMove(item)"><b>[{{ index + 1 }}]</b></span>
                <div v-if="isShow && isEditPage">
                  <span @click="openEdit(item)">{{ getTitle(item) }}</span>
                  <Ubutton size="small" icon="217" iconSize="xsmall" state="deactive" @click.native="confirm(getRemoveParam(item), removeItem)"/>
                  <Ubutton size="small" icon="222" iconSize="xsmall" state="deactive" @click.native="openEdit(item)"/>
                  <!-- <div>
                    <Ubutton size="xsmall" icon="edit_but_up" iconSize="xxsmall" state="deactive" class="boxButton" @click.native="changeUp(item)"/>
                    <Ubutton size="xsmall" icon="edit_but_up" iconSize="xxsmall" state="deactive" class="boxButton rotate180" @click.native="changeDown(item)"/>
                  </div> -->
                </div>
                <div v-else-if="isShow && !isEditPage" @click="openView(item)" class="test">
                  <span @click="openView(item)">{{ getTitle(item) }}</span>
                  <!-- <Ubutton size="small" icon="edit_left" iconSize="xsmall" state="deactive" @click.native="openView(item)"/> -->
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <transition name="footnoteEdit-fade" @enter="enter" @after-leave="leave">
          <ul id="footnoteedit" v-if="isEdit">
            <div class="listTitle">
              <span>내용 입력하기</span>
              <UbuttonList size="xsmall" align="right" :data="editButtonList"/>
            </div>
            <UInput type="text" tag="li" v-model="focus.title" placeholder="주석 이름을 입력해 주세요" @enter="itemSave" @esc="isEdit = false">
              <span><b>[{{ focus.count }}]</b></span>
            </UInput>
            <UInput type="textarea" v-model="focus.message" tag="li" placeholder="내용을 입력해 주세요" @enter="itemSave" @esc="isEdit = false">
            </UInput>
          </ul>
        </transition>
        <transition name="footnoteView-fade">
          <ul id="footnoteview" v-if="isView">
            <div class="listTitle">
              <Ubutton size="small" icon="edit_but_dn" iconSize="xsmall" state="deactive" @click.native="isView = false"/>
              <UbuttonList size="xsmall" align="right" :data="viewButtonList"/>
            </div>
            <li>
              <span><b>[{{ focus.count }}]</b></span>
              <span>{{ focus.title }}</span>
            </li>
            <li>{{ focus.message }}</li>
          </ul>
        </transition>
      </div>
      <div class="footbutton" :class="isShow ? 'open' : 'close'">
        <Ubutton v-if="!isShow && isEditPage" size="medium" icon="205" iconSize="xsmall" state="deactive" :round="true" @click.native="createItem">
          <sub>1)</sub>
        </Ubutton>
        <span v-if="!isShow && isEditPage" class="line"/>
        <Ubutton size="medium" :icon="isShow ? '128' : '128 rotate180'" iconSize="small" :round="true" state="deactive" @click.native="toogleOpen"/>
      </div>
    </div>
  </transition>
</template>

<script>
import UInput from '@/components/base/UInput.vue'
import ES from '@/components/js/EditorSetting.js'
import {selection, closest, resetRange, getTime} from '@/components/js/Utils.js'

var hrefName = '#ufn'
var idName = 'ufnv'

export default {
  props: {
    data: { type: Array },
    isShow: { type: Boolean, default: true },
    changeView: { type: String, default: '' },
    editType: { type: String },
    type: { type: String, default: 'edit' }
  },
  data: function () {
    return {
      editButtonList: [
        {name: '취소', state: 'deactive', click: () => { this.isEdit = false }},
        {name: '등록', state: 'active', click: this.itemSave}
      ],
      viewButtonList: [{
        name: '닫기',
        state: 'deactive',
        click: () => {
          this.$emit('update:changeView', '')
          this.isView = false
        }}
      ],
      isEdit: false,
      focus: null,
      isView: false,
      cutData: []
    }
  },
  mounted () {
    console.log(this.$center)
    this.$center.addStepEvent(ES.KEYDOWN, 1, this.keydown)
    this.$center.addStepEvent(ES.PASTE, 1, this.paste)
    this.$center.addStepEvent(ES.SELECTION, 1, this.edit_selection)
    this.$center.addStepEvent(ES.REMOVE, 1, this.edit_remove)
    this.$center.addStepEvent(ES.MOUSEDOWN, 1, this.mousedown)
    this.$center.addStepEvent(ES.DRAGSTART, 1, this.dragstart)
  },
  beforeDestroy () {
    this.$center.removeStepEvent(ES.KEYDOWN, this.keydown)
    this.$center.removeStepEvent(ES.PASTE, this.paste)
    this.$center.removeStepEvent(ES.SELECTION, this.edit_selection)
    this.$center.removeStepEvent(ES.REMOVE, this.edit_remove)
    this.$center.removeStepEvent(ES.MOUSEDOWN, this.mousedown)
    this.$center.removeStepEvent(ES.DRAGSTART, this.dragstart)
  },
  name: 'FootNote',
  watch: {
    changeView (value) {
      console.log(value)
      if (value !== '') {
        this.focus = this.data.find((item) => item.id === value)
        this.$emit('update:isShow', true)
        this.isView = true
      }
    }
  },
  computed: {
    isEditPage () {
      return this.type === 'edit'
    },
    prevfocus () {
      var idx = this.data.indexOf(this.focus) - 1
      return (idx < 0) ? this.data[this.data.length - 1] : this.data[idx]
    },
    nextfocus () {
      var idx = this.data.indexOf(this.focus) + 1
      return (idx === this.data.length) ? this.data[0] : this.data[idx]
    }
  },
  methods: {
    mousedown (e) {
      if (closest(e.target, 'a')) {
        if (this.isItem(closest(e.target, 'a'))) {
          return ES.TYPE_FOOTNOTE
        }
      }
    },
    keydown (e) {
      // console.log('keydown', this, e)
      var s = selection()
      var item, sn
      if (!e.ctrlKey && !e.shiftKey && !e.altKey) {
        switch (e.keyCode || e.which) {
          case 8 :
            // console.log(s)
            if (s.anchorOffset !== 0) {
              this.keyremove(this.checkItem(s.anchorNode), e)
              // console.log('footnote', e)
            }
            break
          case 46 :
          // delete
            sn = s.anchorNode
            if (sn.length !== s.anchorOffset) {
              this.keyremove(this.checkItem(sn), e)
            } else {
              if (sn.nextSibling) {
                this.keyremove(this.checkItem(sn.nextSibling), e)
              }
            }
            break
          case 13 :
          // enter
            sn = s.anchorNode
            item = this.checkItem(sn)
            if (item && sn.length !== s.anchorOffset) {
              e.preventDefault()
            }
            break
          case 37 :
          case 38 :
          case 39 :
          case 40 :
            break
          default :
            switch (this.editType) {
              case ES.TYPE_FOOTNOTE :
                item = s.anchorNode.parentNode.nextSibling
                resetRange(item, 0)
                e.preventDefault()
                break
            }
            break
        }
      }
    },
    isItem (t) {
      return t && t.id.indexOf(idName) !== -1
    },
    checkItem (t) {
      var p = closest(t, 'a')
      if (p) {
        return this.searchItem(p.id)
      }
      return null
    },
    edit_selection (e) {
      if (ES.hasSelection(e.range, this.selectionCheck, this.checkItem).length) {
        return '주석'
      }
    },
    selectionCheck (s, t, ar) {
      t.querySelectorAll('a').forEach((n) => {
        if (this.isItem(n) && s.containsNode(n)) {
          ar.push(this.checkItem(n))
        }
      })
    },
    keyremove (item, e) {
      // console.log('keyremove', item)
      if (item) {
        e.preventDefault()
        setTimeout(() => {
          this.confirm(this.getRemoveParam(item), this.removeItem)
        })
      }
    },
    paste (e) {
      // console.log('FootNote', e.pasteHTML, this.cutData)
      e.pasteHTML.querySelectorAll('a').forEach((item) => {
        var i, t
        for (i = 0; i < this.cutData.length; i++) {
          if (this.cutData[i].id === item.id) {
            t = this.cutData.splice(i, 1)[0]
            break
          }
        }
        if (t) {
          this.itemCreate(t.title, t.message, item)
        } else if (document.querySelector('#' + item.id)) {
          t = this.searchItem(item.id)
          this.itemCreate(t.title, t.message, item)
        }
      })
    },
    createItem () {
      switch (this.editType) {
        case ES.TYPE_LINE :
        case ES.TYPE_IMG :
        case ES.TYPE_SECTION :
          this.alert('주석을 생성할수 없습니다.')
          break
        default :
          this.$emit('update:isShow', true)
          this.focus = this.itemCreate()
          this.$emit('action', 'create', this.focus)
          this.isEdit = true
          setTimeout(() => {
            this.resetCount()
          })
          break
      }
    },
    itemCreate (title, message, element) {
      var i = this.data.length + 1
      var t = getTime()
      var d = {href: hrefName + t, id: idName + t, count: i}
      this.data.push(d)
      this.$emit('update:data', this.data)
      if (element) {
        element.href = d.href
        element.id = d.id
        element.innerHTML = '[' + d.count + ']'
        element.style = null
        element.removeAttribute('style')
        setTimeout(() => {
          this.getElement(d)
        })
      } else {
        var h = document.createElement('a')
        h.href = d.href
        h.id = d.id
        h.innerHTML = '[' + d.count + ']'
        d.element = h
      }
      if (title) {
        d.title = title
      }
      if (message) {
        d.message = message
      }
      return d
    },
    toogleOpen () {
      console.log('toogle')
      this.isEdit = false
      this.isView = false
      this.$emit('update:isShow', !this.isShow)
    },
    getTitle (item) {
      if (item.title !== undefined && item.title !== '') {
        return item.title
      } else if (item.message !== undefined && item.message !== '') {
        return item.message
      } else {
        return ''
      }
    },
    getRemoveParam (item) {
      return {
        target: '[' + item.count + '] ' + this.getTitle(item).substring(0, 15),
        message: '주석을 삭제 하시겠습니까?',
        icon: 'edit_delete',
        param: item
      }
    },
    enter: function (el, done) {
      this.$emit('onChange', 'enter')
      var t = document.querySelector('#footnoteedit input')
      t.value = (this.focus.title === undefined) ? '' : this.focus.title
      document.querySelector('#footnoteedit input').focus()
      t = document.querySelector('#footnoteedit textarea')
      t.value = (this.focus.message === undefined) ? '' : this.focus.message
    },
    leave: function (el, done) {
      this.focus = null
      this.$emit('update:isCreate', false)
      this.$emit('onChange', 'leave')
    },
    bodyMove (e) {
      this.getElement(e).scrollIntoView()
      // e.element.scrollIntoView()
    },
    openEdit (e) {
      this.focus = e
      this.isEdit = true
    },
    edit_remove (e) {
      this.isEdit = false
      console.log('FootNote remove', e)
      var item
      if (e.range) {
        item = ES.hasSelection(e.range, this.selectionCheck, this.checkItem)
      } else {
        item = ES.hasSelection(this.selectionCheck, this.checkItem)
      }
      if (e.type === 'cut') {
        this.cutData = item
      }
      console.log('FootNote hasSelection', item)
      item.forEach((n) => {
        var el = document.querySelector('#' + n.id)
        console.log('edit_remove', el)
        if (el && el.parentNode) {
          el.parentNode.removeChild(el)
        }
        if (e.type !== 'drop') {
          this.data.splice(this.data.indexOf(n), 1)
        }
      })
      setTimeout(() => {
        this.resetCount()
      })
    },
    removeItem (e) {
      console.log(e, this)
      // console.log(this.cutData)
      if (e.result) {
        this.isEdit = false
        var item = e.param
        var t = this.getElement(item)
        if (t) {
          t.parentNode.removeChild(t)
        }
        this.data.splice(this.data.indexOf(item), 1)
        this.resetCount()
      }
    },
    searchItem (id) {
      return this.data.find((el) => el.id === id)
    },
    changeUp (e) {
      var idx = this.data.indexOf(e)
      if (idx) {
        var item = this.data.splice(idx, 1)
        this.data.splice(idx - 1, 0, item[0])
        this.resetCount()
      }
    },
    changeDown (e) {
      var idx = this.data.indexOf(e)
      var item = this.data.splice(idx, 1)
      this.data.splice(idx + 1, 0, item[0])
      this.resetCount()
    },
    itemSave () {
      console.log('itemsave')
      this.focus.title = document.querySelector('#footnoteedit input').value
      this.focus.message = document.querySelector('#footnoteedit textarea').value
      this.isEdit = false
    },
    resetCount () {
      var idx = 1
      document.querySelectorAll('a').forEach((n, i) => {
        var d = this.searchItem(n.id)
        if (d !== undefined) {
          d.count = idx
          var t = this.getElement(d)
          t.innerHTML = '[' + d.count + ']'
          idx++
        }
      })
      this.data.sort((a, b) => {
        return a.count > b.count ? 1 : -1
      })
      // this.data.forEach((item, idx) => {
      //   var t = this.getElement(item)
      //   item.count = idx + 1
      //   t.innerHTML = '[' + item.count + ']'
      //   console.log(t, item)
      // })
      this.$emit('update:data', this.data)
    },
    openView (e) {
      this.focus = e
      this.isView = true
    },
    getElement (item) {
      if ((item && !item.element) || (item.element !== document.querySelector('#' + item.id))) {
        item.element = document.querySelector('#' + item.id)
      }
      return item.element
    },
    dragstart (e) {
    }
  },
  components: {
    'UInput': UInput
  }
}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
#footnote {
  /* position: absolute; */
  display: flex;
  flex-direction: column;
  /* top: 0; */
  /* left: 0; */
  height: 100%;
  width: 300px;
  color: var(--text-base);
  background-color: var(--bg-white);
  z-index: 2;
}
#footnote.open {
  width: 300px;
}
#footnote.close {
  width: 55px;
}
#footnote .container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.listcontainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
.listTitle {
  display: inline-flex;
  height: 40px;
  padding-left: 5px;
  padding-right: 5px;
  align-items: center;
  color: var(--text-title);
  background-color: var(--disable);
  box-sizing: border-box;
}
.listTitle.open.edit {
  justify-content: flex-start;
}
.listTitle.open.view {
  justify-content: center;
}
.listTitle.close {
  justify-content: center;
}
.listTitle > span:first-child{
  display: flex;
  flex: none;
  margin: 0;
  max-width: 100%;
  font-weight: bold;
}
.list {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
#footnotelist,
#footnoteedit,
#footnoteview {
  flex-direction: column;
  width: 100%;
  border: 1px solid var(--line-guide);
}
#footnotelist {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.footnoteItem {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 50px;
  padding-left: 5px;
  padding-right: 5px;
  border-bottom: 1px solid var(--line-guide);
  font-size: 13px;
}
.footnoteItem > span {
  flex: none;
  margin: 0;
  display: flex;
  flex: auto;
  height: 100%;
  align-items: center;
  background-color: var(--bg-white);
  cursor: pointer;
  justify-content: center;
  min-width: 40px;
}
.footnoteItem b {
  color: var(--text-title);
}
.footnoteItem.open {
  justify-content: flex-start;
}
.footnoteItem.close {
  justify-content: center;
}
.footnoteItem > div > span {
  display: -webkit-box;
  flex: auto;
  width: 120px;
  max-height: 40px;
  /* height: 100%; */
  /* vertical-align: middle; */
  text-align: left;
  /* align-items: center; */
  margin-left: 10px;
  background-color: var(--bg-white);
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  -webkit-box-align: start;
}
.footnoteItem > div {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}
.boxButton {
  border: 1px solid var(--line-base);
  background-color: var(--disable);
}
#footnoteedit,
#footnoteview {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  background-color: var(--bg-white);
  height: 100%;
}
#footnoteedit li ,
#footnoteview li {
  display: flex;
  align-items: center;
  height: 50px;
  margin: 0px 5px 0px 5px;
}
#footnoteedit li:last-child,
#footnoteview li:last-child {
  flex: auto;
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
}
#footnoteedit .input {
  margin: 0px 5px 0px 5px;
}
#footnoteview li {
  border-bottom: 1px solid var(--line-guide);
}
.footbutton {
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  vertical-align: middle;
  width: 100%;
  border: 1px solid var(--line-guide);
  border-top: none;
  background-color: var(--disable);
  cursor: pointer;
}
.footbutton.open div {
  margin: 5px 5px 5px 5px;
}
.footbutton.close div {
  margin: 2px 2px 2px 2px;
}
.footbutton span {
  margin: 0 auto;
}
.footbutton div sub {
  font-size: 0.5em;
  margin-left: -2px;
  margin-bottom: -8px;
}
.footbutton div {
  width: auto;
  background-color: var(--bg-white);
}
.footbutton div:hover {
  color: var(--bg-white);
  background-color: var(--deactive);
}
.footbutton .line {
  margin: 1px 0px 1px 0px;
  border-bottom: 1px solid var(--line-guide);
}
.footnoteEdit-fade-enter-active {
  transition: all .2s ease;
}
.footnoteEdit-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.footnoteEdit-fade-enter, .footnoteEdit-fade-leave-to {
  transform: translateX(-300px);
}
.footnote-fade-enter-active {
  transition: all .2s ease;
}
.footnote-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.footnote-fade-enter, .footnote-fade-leave-to {
  transform: translateX(-300px);
}
.footnoteView-fade-enter-active {
  transition: all .2s ease;
}
.footnoteView-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.footnoteView-fade-enter, .footnoteView-fade-leave-to {
  transform: translateX(-300px);
}
</style>



// WEBPACK FOOTER //
// src/components/edit/FootNote.vue